'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
export const BLENDER_DOWNLOAD_URL = 'https://www.blender.org/download/';
interface BuildLightmapDialogProps {
  open: boolean;
  blenderPath?: string;
  errorMessage?: string;
  invalidSelectionMessage?: string;
  canStart: boolean;
  isBusy: boolean;
  showInstallBlender: boolean;
  onCancel: () => void;
  onInstall: () => void;
  onBrowseForBlender: () => void;
  onResetBlenderPath: () => void;
  onDismissInvalidSelection: () => void;
  onStart: () => void;
}
export const BuildLightmapDialog = t0 => {
  const $ = _c(74);
  const {
    open,
    blenderPath,
    errorMessage,
    invalidSelectionMessage,
    canStart,
    isBusy,
    showInstallBlender,
    onCancel,
    onInstall,
    onBrowseForBlender,
    onResetBlenderPath,
    onDismissInvalidSelection,
    onStart
  } = t0;
  const [resetConfirmOpen, setResetConfirmOpen] = useState(false);
  let t1;
  if ($[0] !== onCancel) {
    t1 = nextOpen => {
      if (!nextOpen) {
        onCancel();
      }
    };
    $[0] = onCancel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogHeader><DialogTitle>Build Lightmap</DialogTitle><DialogDescription>Confirm Blender is available, then start the lightmap bake for the active scene.</DialogDescription></DialogHeader>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-sm font-medium">Blender executable</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = blenderPath?.trim() ? blenderPath : "Not set \u2014 install Blender or browse for its executable below.";
  let t5;
  if ($[4] !== t4) {
    t5 = <div className="space-y-1">{t3}<p className="text-sm text-muted-foreground break-all">{t4}</p></div>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== errorMessage) {
    t6 = errorMessage ? <p className="text-xs text-destructive">{errorMessage}</p> : null;
    $[6] = errorMessage;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isBusy || $[9] !== onInstall || $[10] !== showInstallBlender) {
    t7 = showInstallBlender ? <Button type="button" variant="secondary" onClick={onInstall} disabled={isBusy}>Install Blender</Button> : null;
    $[8] = isBusy;
    $[9] = onInstall;
    $[10] = showInstallBlender;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = isBusy ? "Checking..." : "Browse for Blender";
  let t9;
  if ($[12] !== isBusy || $[13] !== onBrowseForBlender || $[14] !== t8) {
    t9 = <Button type="button" variant="outline" onClick={onBrowseForBlender} disabled={isBusy}>{t8}</Button>;
    $[12] = isBusy;
    $[13] = onBrowseForBlender;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setResetConfirmOpen(true);
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== isBusy) {
    t11 = <Button type="button" variant="ghost" onClick={t10} disabled={isBusy}>Reset</Button>;
    $[17] = isBusy;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t7 || $[21] !== t9) {
    t12 = <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">{t7}{t9}{t11}</div>;
    $[19] = t11;
    $[20] = t7;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== isBusy || $[24] !== onCancel) {
    t13 = <Button type="button" variant="ghost" onClick={onCancel} disabled={isBusy}>Cancel</Button>;
    $[23] = isBusy;
    $[24] = onCancel;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = !canStart || isBusy;
  let t15;
  if ($[26] !== onStart || $[27] !== t14) {
    t15 = <Button type="button" onClick={onStart} disabled={t14}>Start</Button>;
    $[26] = onStart;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t13 || $[30] !== t15) {
    t16 = <DialogFooter className="gap-2 sm:gap-0">{t13}{t15}</DialogFooter>;
    $[29] = t13;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t12 || $[33] !== t16 || $[34] !== t5 || $[35] !== t6) {
    t17 = <DialogContent className="max-w-md">{t2}{t5}{t6}{t12}{t16}</DialogContent>;
    $[32] = t12;
    $[33] = t16;
    $[34] = t5;
    $[35] = t6;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== open || $[38] !== t1 || $[39] !== t17) {
    t18 = <Dialog open={open} onOpenChange={t1}>{t17}</Dialog>;
    $[37] = open;
    $[38] = t1;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  const t19 = Boolean(invalidSelectionMessage);
  let t20;
  if ($[41] !== onDismissInvalidSelection) {
    t20 = nextOpen_0 => {
      if (!nextOpen_0) {
        onDismissInvalidSelection();
      }
    };
    $[41] = onDismissInvalidSelection;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <AlertDialogTitle>Invalid Blender Executable</AlertDialogTitle>;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== invalidSelectionMessage) {
    t22 = <AlertDialogHeader>{t21}<AlertDialogDescription className="break-words">{invalidSelectionMessage}</AlertDialogDescription></AlertDialogHeader>;
    $[44] = invalidSelectionMessage;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== isBusy || $[47] !== onDismissInvalidSelection) {
    t23 = <AlertDialogFooter><AlertDialogAction disabled={isBusy} onClick={onDismissInvalidSelection}>OK</AlertDialogAction></AlertDialogFooter>;
    $[46] = isBusy;
    $[47] = onDismissInvalidSelection;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t22 || $[50] !== t23) {
    t24 = <AlertDialogContent>{t22}{t23}</AlertDialogContent>;
    $[49] = t22;
    $[50] = t23;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t19 || $[53] !== t20 || $[54] !== t24) {
    t25 = <AlertDialog open={t19} onOpenChange={t20}>{t24}</AlertDialog>;
    $[52] = t19;
    $[53] = t20;
    $[54] = t24;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <AlertDialogHeader><AlertDialogTitle>Reset Blender Path?</AlertDialogTitle><AlertDialogDescription>Your saved Blender executable path will be removed. The app will look for Blender in standard install locations instead.</AlertDialogDescription></AlertDialogHeader>;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== isBusy) {
    t27 = <AlertDialogCancel disabled={isBusy}>Cancel</AlertDialogCancel>;
    $[57] = isBusy;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== onResetBlenderPath) {
    t28 = () => {
      setResetConfirmOpen(false);
      onResetBlenderPath();
    };
    $[59] = onResetBlenderPath;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== isBusy || $[62] !== t28) {
    t29 = <AlertDialogAction disabled={isBusy} onClick={t28}>Reset</AlertDialogAction>;
    $[61] = isBusy;
    $[62] = t28;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== t27 || $[65] !== t29) {
    t30 = <AlertDialogContent>{t26}<AlertDialogFooter>{t27}{t29}</AlertDialogFooter></AlertDialogContent>;
    $[64] = t27;
    $[65] = t29;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  let t31;
  if ($[67] !== resetConfirmOpen || $[68] !== t30) {
    t31 = <AlertDialog open={resetConfirmOpen} onOpenChange={setResetConfirmOpen}>{t30}</AlertDialog>;
    $[67] = resetConfirmOpen;
    $[68] = t30;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] !== t18 || $[71] !== t25 || $[72] !== t31) {
    t32 = <>{t18}{t25}{t31}</>;
    $[70] = t18;
    $[71] = t25;
    $[72] = t31;
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  return t32;
};
BuildLightmapDialog.displayName = 'BuildLightmapDialog';